// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.SimpleInput_container__V1N9l {
  position: relative;
  width: 100%;
  background-color: transparent;
}
.SimpleInput_label__q5xJN {
  position: absolute;
  z-index: 0;
  transition: all 0.2s ease-out;
  background-color: transparent;
  padding: 0 4px;
  border-radius: 5px;
  display: flex;
  align-items: center;
  justify-content: flex-start;
  height: 32px;
  width: calc(100% - 8px) !important;
}
.SimpleInput_allBorderLabel__azz1Q {
  text-overflow: ellipsis;
  white-space: nowrap;
  overflow: hidden;
  position: absolute;
  z-index: 0;
  transition: all 0.2s ease-out;
  background-color: transparent;
  padding: 0 6px;
  border-radius: 5px;
}
.SimpleInput_iconContainer__prcz1 {
  display: flex;
  align-items: center;
  justify-content: center;
  margin-inline-end: 4px;
}
.SimpleInput_txtLabel__XJJBg {
  text-overflow: ellipsis;
  white-space: nowrap;
  overflow: hidden;
}
.SimpleInput_marginStart__nu6iT {
  margin-inline-start: 12px;
}
.SimpleInput_labelUp__UHL39 {
  top: -10px;
  cursor: default;
}
.SimpleInput_labelUp__UHL39 svg {
  transform: scale(0.9);
}
.SimpleInput_allBorderLabelUp__vNoGW {
  top: -12px;
  cursor: default;
}
.SimpleInput_labelDown__J9QX6 {
  top: 11px;
  cursor: text;
}
.SimpleInput_addFormInput__IbRjL {
  width: 100%;
  height: 50px;
  padding-block-start: 20px;
  padding-block-end: 5px;
  padding-inline: 16px;
  outline: none;
  display: flex;
  align-items: center;
  justify-content: center;
  transition: all 0.2s ease-out;
  background-color: transparent;
}
.SimpleInput_addFormInputAllBorder__HCOnm {
  width: 100%;
  height: 50px;
  padding-block: 5px;
  padding-inline: 16px;
  outline: none;
  display: flex;
  align-items: center;
  justify-content: center;
  transition: all 0.2s ease-out;
  background-color: transparent;
}
.SimpleInput_allBorders__JfhgB {
  border: 1px solid #979797;
  border-radius: 4px;
}
.SimpleInput_pinkBorder__nwBla {
  border-color: #e04c76;
  border-width: 2px;
}
.SimpleInput_pinkColor__94su- {
  color: #e04c76;
  fill: #e04c76;
}
.SimpleInput_ltrInput__UbyOy {
  direction: ltr !important;
}
.SimpleInput_helperTxtContainer__CLvXB {
  display: flex;
  align-items: flex-start;
  column-gap: 6px;
  height: 29px;
  padding-block-start: 4px;
}
.SimpleInput_helperTxtIcon__mTLwu {
  display: flex;
  align-items: center;
  transform: translateY(5px);
}
.SimpleInput_questionIcon__QZJEd {
  width: 20px;
  height: 20px;
  margin-top: -2px;
}
.SimpleInput_passIcon__ytIQi {
  color: #737373;
  cursor: pointer;
  position: absolute;
  top: 22px;
  right: 7px;
}
.SimpleInput_allBorderPassIcon__EtDx3 {
  color: #737373;
  cursor: pointer;
  position: absolute;
  top: 15px;
  right: 9px;
}
.SimpleInput_mandatorySign__JoJEh {
  padding-inline-start: 5px;
}
.SimpleInput_largeCenteredInput__Rdmxs {
  text-align: center;
  font-size: 24px;
  font-weight: 600;
  letter-spacing: 12px;
  padding-block-end: 12px;
}
.SimpleInput_forcePe__xRv5u {
  font-family: Estedad !important;
}
`, "",{"version":3,"sources":["webpack://./src/Components/UI/SimpleInput/SimpleInput.module.css"],"names":[],"mappings":"AAAA;EACE,kBAAkB;EAClB,WAAW;EACX,6BAA6B;AAC/B;AACA;EACE,kBAAkB;EAClB,UAAU;EACV,6BAA6B;EAC7B,6BAA6B;EAC7B,cAAc;EACd,kBAAkB;EAClB,aAAa;EACb,mBAAmB;EACnB,2BAA2B;EAC3B,YAAY;EACZ,kCAAkC;AACpC;AACA;EACE,uBAAuB;EACvB,mBAAmB;EACnB,gBAAgB;EAChB,kBAAkB;EAClB,UAAU;EACV,6BAA6B;EAC7B,6BAA6B;EAC7B,cAAc;EACd,kBAAkB;AACpB;AACA;EACE,aAAa;EACb,mBAAmB;EACnB,uBAAuB;EACvB,sBAAsB;AACxB;AACA;EACE,uBAAuB;EACvB,mBAAmB;EACnB,gBAAgB;AAClB;AACA;EACE,yBAAyB;AAC3B;AACA;EACE,UAAU;EACV,eAAe;AACjB;AACA;EACE,qBAAqB;AACvB;AACA;EACE,UAAU;EACV,eAAe;AACjB;AACA;EACE,SAAS;EACT,YAAY;AACd;AACA;EACE,WAAW;EACX,YAAY;EACZ,yBAAyB;EACzB,sBAAsB;EACtB,oBAAoB;EACpB,aAAa;EACb,aAAa;EACb,mBAAmB;EACnB,uBAAuB;EACvB,6BAA6B;EAC7B,6BAA6B;AAC/B;AACA;EACE,WAAW;EACX,YAAY;EACZ,kBAAkB;EAClB,oBAAoB;EACpB,aAAa;EACb,aAAa;EACb,mBAAmB;EACnB,uBAAuB;EACvB,6BAA6B;EAC7B,6BAA6B;AAC/B;AACA;EACE,yBAAyB;EACzB,kBAAkB;AACpB;AACA;EACE,qBAAqB;EACrB,iBAAiB;AACnB;AACA;EACE,cAAc;EACd,aAAa;AACf;AACA;EACE,yBAAyB;AAC3B;AACA;EACE,aAAa;EACb,uBAAuB;EACvB,eAAe;EACf,YAAY;EACZ,wBAAwB;AAC1B;AACA;EACE,aAAa;EACb,mBAAmB;EACnB,0BAA0B;AAC5B;AACA;EACE,WAAW;EACX,YAAY;EACZ,gBAAgB;AAClB;AACA;EACE,cAAc;EACd,eAAe;EACf,kBAAkB;EAClB,SAAS;EACT,UAAU;AACZ;AACA;EACE,cAAc;EACd,eAAe;EACf,kBAAkB;EAClB,SAAS;EACT,UAAU;AACZ;AACA;EACE,yBAAyB;AAC3B;AACA;EACE,kBAAkB;EAClB,eAAe;EACf,gBAAgB;EAChB,oBAAoB;EACpB,uBAAuB;AACzB;AACA;EACE,+BAA+B;AACjC","sourcesContent":[".container {\r\n  position: relative;\r\n  width: 100%;\r\n  background-color: transparent;\r\n}\r\n.label {\r\n  position: absolute;\r\n  z-index: 0;\r\n  transition: all 0.2s ease-out;\r\n  background-color: transparent;\r\n  padding: 0 4px;\r\n  border-radius: 5px;\r\n  display: flex;\r\n  align-items: center;\r\n  justify-content: flex-start;\r\n  height: 32px;\r\n  width: calc(100% - 8px) !important;\r\n}\r\n.allBorderLabel {\r\n  text-overflow: ellipsis;\r\n  white-space: nowrap;\r\n  overflow: hidden;\r\n  position: absolute;\r\n  z-index: 0;\r\n  transition: all 0.2s ease-out;\r\n  background-color: transparent;\r\n  padding: 0 6px;\r\n  border-radius: 5px;\r\n}\r\n.iconContainer {\r\n  display: flex;\r\n  align-items: center;\r\n  justify-content: center;\r\n  margin-inline-end: 4px;\r\n}\r\n.txtLabel {\r\n  text-overflow: ellipsis;\r\n  white-space: nowrap;\r\n  overflow: hidden;\r\n}\r\n.marginStart {\r\n  margin-inline-start: 12px;\r\n}\r\n.labelUp {\r\n  top: -10px;\r\n  cursor: default;\r\n}\r\n.labelUp svg {\r\n  transform: scale(0.9);\r\n}\r\n.allBorderLabelUp {\r\n  top: -12px;\r\n  cursor: default;\r\n}\r\n.labelDown {\r\n  top: 11px;\r\n  cursor: text;\r\n}\r\n.addFormInput {\r\n  width: 100%;\r\n  height: 50px;\r\n  padding-block-start: 20px;\r\n  padding-block-end: 5px;\r\n  padding-inline: 16px;\r\n  outline: none;\r\n  display: flex;\r\n  align-items: center;\r\n  justify-content: center;\r\n  transition: all 0.2s ease-out;\r\n  background-color: transparent;\r\n}\r\n.addFormInputAllBorder {\r\n  width: 100%;\r\n  height: 50px;\r\n  padding-block: 5px;\r\n  padding-inline: 16px;\r\n  outline: none;\r\n  display: flex;\r\n  align-items: center;\r\n  justify-content: center;\r\n  transition: all 0.2s ease-out;\r\n  background-color: transparent;\r\n}\r\n.allBorders {\r\n  border: 1px solid #979797;\r\n  border-radius: 4px;\r\n}\r\n.pinkBorder {\r\n  border-color: #e04c76;\r\n  border-width: 2px;\r\n}\r\n.pinkColor {\r\n  color: #e04c76;\r\n  fill: #e04c76;\r\n}\r\n.ltrInput {\r\n  direction: ltr !important;\r\n}\r\n.helperTxtContainer {\r\n  display: flex;\r\n  align-items: flex-start;\r\n  column-gap: 6px;\r\n  height: 29px;\r\n  padding-block-start: 4px;\r\n}\r\n.helperTxtIcon {\r\n  display: flex;\r\n  align-items: center;\r\n  transform: translateY(5px);\r\n}\r\n.questionIcon {\r\n  width: 20px;\r\n  height: 20px;\r\n  margin-top: -2px;\r\n}\r\n.passIcon {\r\n  color: #737373;\r\n  cursor: pointer;\r\n  position: absolute;\r\n  top: 22px;\r\n  right: 7px;\r\n}\r\n.allBorderPassIcon {\r\n  color: #737373;\r\n  cursor: pointer;\r\n  position: absolute;\r\n  top: 15px;\r\n  right: 9px;\r\n}\r\n.mandatorySign {\r\n  padding-inline-start: 5px;\r\n}\r\n.largeCenteredInput {\r\n  text-align: center;\r\n  font-size: 24px;\r\n  font-weight: 600;\r\n  letter-spacing: 12px;\r\n  padding-block-end: 12px;\r\n}\r\n.forcePe {\r\n  font-family: Estedad !important;\r\n}\r\n"],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {
	"container": `SimpleInput_container__V1N9l`,
	"label": `SimpleInput_label__q5xJN`,
	"allBorderLabel": `SimpleInput_allBorderLabel__azz1Q`,
	"iconContainer": `SimpleInput_iconContainer__prcz1`,
	"txtLabel": `SimpleInput_txtLabel__XJJBg`,
	"marginStart": `SimpleInput_marginStart__nu6iT`,
	"labelUp": `SimpleInput_labelUp__UHL39`,
	"allBorderLabelUp": `SimpleInput_allBorderLabelUp__vNoGW`,
	"labelDown": `SimpleInput_labelDown__J9QX6`,
	"addFormInput": `SimpleInput_addFormInput__IbRjL`,
	"addFormInputAllBorder": `SimpleInput_addFormInputAllBorder__HCOnm`,
	"allBorders": `SimpleInput_allBorders__JfhgB`,
	"pinkBorder": `SimpleInput_pinkBorder__nwBla`,
	"pinkColor": `SimpleInput_pinkColor__94su-`,
	"ltrInput": `SimpleInput_ltrInput__UbyOy`,
	"helperTxtContainer": `SimpleInput_helperTxtContainer__CLvXB`,
	"helperTxtIcon": `SimpleInput_helperTxtIcon__mTLwu`,
	"questionIcon": `SimpleInput_questionIcon__QZJEd`,
	"passIcon": `SimpleInput_passIcon__ytIQi`,
	"allBorderPassIcon": `SimpleInput_allBorderPassIcon__EtDx3`,
	"mandatorySign": `SimpleInput_mandatorySign__JoJEh`,
	"largeCenteredInput": `SimpleInput_largeCenteredInput__Rdmxs`,
	"forcePe": `SimpleInput_forcePe__xRv5u`
};
export default ___CSS_LOADER_EXPORT___;
